import { Link, useLocation } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { ROUTES } from '@/constants/routes'

/**
 * Sign in page when Okta is configured. Single "Sign in with Okta" button
 * that redirects to Okta-hosted sign-in. Same two-column layout as legacy SignIn.
 */
export default function SignInOkta() {
  const { oktaAuth, authState } = useOktaAuth()
  const location = useLocation()

  // If already authenticated, redirect to dashboard
  if (authState?.isAuthenticated) {
    window.location.href = ROUTES.DASHBOARD
    return null
  }

  const handleSignIn = () => {
    // Use the "from" location saved by RequireAuth, or default to dashboard
    const returnTo = (location.state as { from?: string })?.from || ROUTES.DASHBOARD
    oktaAuth.signInWithRedirect({ originalUri: returnTo })
  }

  return (
    <div className="min-h-screen flex">
      {/* Left column - Form */}
      <div className="w-full lg:w-[55%] xl:w-[50%] flex flex-col bg-white px-6 sm:px-10 py-8 lg:py-12 overflow-y-auto">
        <div className="max-w-[420px] mx-auto w-full">
          {/* Logo - centred on left side */}
          <div className="flex justify-center mb-10">
            <Link to={ROUTES.DASHBOARD}>
              <img
                src="/images/logo.png"
                alt="KAY CURZI GROUP"
                className="object-contain"
                style={{ width: 210, height: 101 }}
              />
            </Link>
          </div>

          <h2
            className="font-lexend font-bold text-2xl mb-1"
            style={{ color: '#212126' }}
          >
            Sign in to your account
          </h2>
          <p className="text-black-sub text-sm mb-6">
            Don&apos;t have account?{' '}
            <Link
              to={ROUTES.SIGNUP}
              className="font-medium hover:underline"
              style={{ color: '#2C71F6' }}
            >
              Sign up
            </Link>
          </p>

          <button
            type="button"
            onClick={handleSignIn}
            className="w-full py-3.5 rounded-lg font-lexend font-semibold text-sm text-white transition-colors hover:opacity-95"
            style={{ backgroundColor: '#212126' }}
          >
            Sign in with Okta
          </button>

          <p className="text-black-sub text-xs font-sans mt-6 text-center">
            You will be redirected to your organization&apos;s sign-in page.
          </p>
        </div>
      </div>

      {/* Right column - Hero image (cargo ship) */}
      <div
        className="hidden lg:block lg:flex-1 bg-cover bg-center bg-no-repeat min-h-screen"
        style={{
          backgroundImage: 'url(/images/signup-hero.jpeg)',
          backgroundColor: '#0f172a',
        }}
        role="img"
        aria-label="Cargo ship at port at night"
      />
    </div>
  )
}
